const MenuItemList = [
  {
    label: "Blog",
    link: "https://blog.coreblockchain.net/"
  },
  {
    label: "Developers",
    link: "https://dev.coreblockchain.net/"
  },
  {
    label: "Talk",
    link: "https://coretalk.space/"
  }
]

const TargetIndustries = [
  {
    tabName: "Finance & Payments",
    tabImage: '/images/trading.jpg',
    tabContent: "Secure Smart Contracts streamline borderless payments and encrypted financial messaging, transforming global transactions."
  },
  {
    tabName: "Healthcare & Wellness",
    tabImage: '/images/healthcare.jpg',
    tabContent: "Enhance medical data protection and facilitate research with blockchain-verified data, improving patient outcomes and research efficiency."
  },
  {
    tabName: "Aerospace",
    tabImage: '/images/space.jpg',
    tabContent: "Ensure transparent and reliable data sharing for aircraft history and operations with blockchain-certified records."
  },
  {
    tabName: "Energy",
    tabImage: '/images/energy.jpg',
    tabContent: "Drive IoT and small device optimization with eco-friendly mining focused on CPU algorithms contributing to sustainable energy consumption."
  },
  {
    tabName: "Supply Chain",
    tabImage: '/images/supply.jpg',
    tabContent: "Implement blockchain for resilient supply chain management, enhancing tracking, monitoring, and reducing intermediaries."
  },
  {
    tabName: "Governance & DAOs",
    tabImage: '/images/egov.jpg',
    tabContent: "Offer transparent, immutable digital governance solutions for streamlined, trusted and secure services."
  },
  {
    tabName: "Mass Media",
    tabImage: '/images/massmedia.jpg',
    tabContent: "Empower Indie producers with blockchain-enabled microfinancing and content monetization."
  },
  {
    tabName: "GIScience",
    tabImage: '/images/GIS.jpg',
    tabContent: "Support digital trust in multiple industries using fingerprint protocol attributes  for GIScience."
  },
  {
    tabName: "Defence & Security",
    tabImage: '/images/defense.jpg',
    tabContent: "Provide secure global communication with Autonomous Pod Data Transport (APDT) within the Core Blockchain Network."
  },
  {
    tabName: "Asset Tokenization",
    tabImage: '/images/tokenization.jpg',
    tabContent: "Secure various assets on our platform, hosting multiple securities with blockchain technology."
  },
  {
    tabName: "Education",
    tabImage: '/images/education.jpg',
    tabContent: "Facilitate learning through blockchain-aided educational processes."
  },
  {
    tabName: "Telecommunications",
    tabImage: '/images/telecomunications.jpg',
    tabContent: "Innovate communications with blockchain for data distribution, covering RF, meshnet, and laser transmission."
  }
]

const DeveloperTabs = [
  {
    tabName: "Developer Portal",
    tabContent: "Explore the interface between a set of APIs, SDKs, or other interactive digital tools and their various stakeholders. Connect blockchain to your running system using Oracles. Interact with blockchain worldwide network.",
    tabGreenBtn: "Visit",
    tabGreenBtnLink: "https://dev.coreblockchain.net/",
    tabGhostBtn: "Report Bug",
    tabGhostBtnLink: "https://dev.coreblockchain.net/vulnerability"
  },
  {
    tabName: "Core Talk",
    tabContent: "Discuss and open new QA in the Talk community. Developers as well as other community members will assist you to answer your questions.",
    tabGreenBtn: "Visit",
    tabGreenBtnLink: "https://coretalk.space/",
    tabGhostBtn: "Explore $XCB on X",
    tabGhostBtnLink: "https://twitter.com/search?q=%24XCB"
  },
  {
    tabName: "Core Standards",
    tabContent: "The Core community has adopted many standards that are helpful for developers. Typically these are introduced as Core Improvement Proposals //CIP//. CIPs describe standards for the Core platform, including core protocol specifications, client APIs, and contract standards.",
    tabGreenBtn: "Visit",
    tabGreenBtnLink: "https://cip.coreblockchain.net/",
    tabGhostBtn: "Open an Issue",
    tabGhostBtnLink: "https://github.com/core-coin/cip/issues/new/choose"
  }
]

const WalletsTabs = [
  {
    tabName: "CorePass",
    tabContent: "CorePass serves as your gateway to the vast and innovative world of the Core Ecosystem, offering effortless integration into a diverse range of cutting-edge blockchain services tailored for tomorrow's needs. It's more than just a wallet; it's a secure digital haven for your identity, along with XCB (Core Coin) and CTN (Core Token), all seamlessly integrated within the Core Blockchain Network.",
    tabGreenBtn: "Google Play",
    tabGreenBtnLink: "https://play.google.com/store/apps/details?id=net.corepass.app",
    tabGhostBtn: "App Store",
    tabGhostBtnLink: "https://apps.apple.com/app/corepass-id/id1644928641"
  },
  {
    tabName: "XCB Hodler",
    tabContent: "The XCB Hodler App is a dedicated wallet exclusively designed for XCB Core Coins, providing a simplified and efficient transaction experience tailored to the needs of miners. It ensures secure storage of digital assets with an added convenience. This wallet incorporates a feature to import the Core Blockchain UTC file or a private key, enhancing its functionality and user accessibility.",
    tabGreenBtn: "Google Play",
    tabGreenBtnLink: "https://play.google.com/store/apps/details?id=com.xcbhodler.app",
    tabGhostBtn: "App Store",
    tabGhostBtnLink: "https://apps.apple.com/us/app/xcb-hodler/id6449737037"
  }
]

export { MenuItemList, TargetIndustries, DeveloperTabs, WalletsTabs }
